import { Controller } from "@hotwired/stimulus"

// Drops a canned reply into the support reply box (#31).
//
// It inserts at the cursor and never replaces what is already typed: an agent
// part-way through a sentence should not lose it to a mis-click, and two
// templates in one reply is an ordinary thing to want.
export default class extends Controller {
  static targets = ["picker", "body"]

  insert() {
    const option = this.pickerTarget.selectedOptions[0]
    const text = option?.dataset?.body
    if (!text) return

    const field = this.bodyTarget
    const start = field.selectionStart ?? field.value.length
    const end = field.selectionEnd ?? field.value.length
    const before = field.value.slice(0, start)
    const after = field.value.slice(end)

    // A blank line between what was there and what arrives, so two templates do
    // not run into one another.
    const separator = before.length > 0 && !before.endsWith("\n\n") ? "\n\n" : ""
    field.value = `${before}${separator}${text}${after}`

    const caret = before.length + separator.length + text.length
    field.focus()
    field.setSelectionRange(caret, caret)
    field.dispatchEvent(new Event("input", { bubbles: true }))

    // Back to the prompt, so picking the same one twice works.
    this.pickerTarget.selectedIndex = 0
  }
}
